export const HAS_WINDOW = typeof window !== 'undefined';
